// extracted by mini-css-extract-plugin
module.exports = {"container":"UserManagement_container__31BnD"};